import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { THEME } from "@/components/@types";
import { onMounted, ref, reactive, watch, nextTick } from 'vue';
import { BaseButton, BaseIcon } from "@/components/@base";
import { useClientStore } from "@/store/client";
import { storeToRefs } from "pinia";
import { VueTelInput } from 'vue-tel-input';
import '@/styles/vue-tel-input.css';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ScriptPhoneStep',
    props: {
        modelValue: { default: null },
        required: { type: Boolean, default: false },
        theme: { default: THEME.light }
    },
    emits: ["update:modelValue", "confirmEntry"],
    setup(__props, { emit: __emit }) {
        const { client } = storeToRefs(useClientStore());
        const props = __props;
        const emits = __emit;
        const phones = ref([null]);
        const temp = ref([]);
        const data = reactive({ ...phones.value });
        const dataChanges = ref(false);
        function addphone() {
            for (let prop in data) {
                phones.value[prop] = data[prop];
            }
            phones.value.push(null);
        }
        function deletePhone(idx) {
            delete data[idx];
            phones.value.splice(idx, 1);
            let i = 0;
            for (let prop in data) {
                phones.value[i] = data[prop];
                i++;
            }
        }
        const dropdownOptions = {
            showDialCodeInList: true,
            showFlags: true,
        };
        const inputOptions = {
            placeholder: ''
        };
        function handleScroll(evt) {
            evt.stopPropagation();
        }
        async function showDropdown() {
            await nextTick();
            const dropdown = document.querySelector('.vue-tel-input .vti__dropdown-list');
            dropdown.addEventListener('wheel', handleScroll);
        }
        function hideDropdown() {
            const dropdown = document.querySelector('.vue-tel-input .vti__dropdown-list');
            dropdown.removeEventListener('wheel', handleScroll);
        }
        function handleEnter() {
            emits('confirmEntry');
        }
        watch(() => data, () => {
            let i = 0;
            temp.value = [];
            for (let prop in data) {
                temp.value[i] = data[prop];
                i++;
            }
            emits('update:modelValue', temp.value.filter((el) => el));
            if (client.value?.phone?.value)
                client.value.phone.value = [...temp.value.filter((el) => el)];
            dataChanges.value = true;
        }, { deep: true });
        watch(() => phones.value, (newVal) => {
            for (let prop in data) {
                delete data[prop];
            }
            newVal.forEach((el, idx) => {
                data[idx] = el;
            });
            if (Object.keys(data).length === 0) {
                data['0'] = '';
            }
        }, { deep: true });
        watch(() => client.value?.phone?.value, (newVal) => {
            if (!dataChanges.value) {
                phones.value = Array.isArray(newVal) ? [...newVal] : [newVal];
                phones.value.length === 0 ? phones.value.push(null) : null;
            }
            dataChanges.value = false;
        }, { deep: true });
        onMounted(() => {
            if (props.modelValue) {
                phones.value = [];
                if (typeof props.modelValue === 'string') {
                    props.modelValue.replace(' ', '').split(',').forEach((el) => {
                        phones.value.push(el);
                    });
                }
                else {
                    props.modelValue.forEach((el) => {
                        phones.value.push(el);
                    });
                }
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phones.value, (phone, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: phone + '' + idx,
                        class: "email-container"
                    }, [
                        _createVNode(_unref(VueTelInput), {
                            modelValue: data[idx],
                            "onUpdate:modelValue": ($event) => ((data[idx]) = $event),
                            class: _normalizeClass(props.required && !data[idx] ? 'error' : ''),
                            required: props.required,
                            "dropdown-options": dropdownOptions,
                            "input-options": inputOptions,
                            mode: "international",
                            autoFormat: true,
                            validCharactersOnly: true,
                            onOpen: showDropdown,
                            onClose: hideDropdown,
                            onEnter: handleEnter
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "required"]),
                        (idx !== 0)
                            ? (_openBlock(), _createBlock(_unref(BaseIcon), {
                                key: 0,
                                name: "delete",
                                size: "24",
                                onClick: ($event) => (deletePhone(idx))
                            }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                    ]));
                }), 128)),
                _createVNode(_unref(BaseButton), {
                    label: "Добавить",
                    theme: props.theme,
                    onClick: addphone
                }, null, 8, ["theme"])
            ]));
        };
    }
});
